import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Button, makeStyles } from "@material-ui/core";
import Loader from "../../common/Loader";
import { axiosInstance } from "../../../utils/axiosInstance.js";

const useStyles = makeStyles({
  approved: {
    color: "#E3F9F1",
    backgroundColor: "#25B273",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
  declined: {
    color: "#fff",
    backgroundColor: "#f92a2aff",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
  approvedStatus: {
    color: "#25B273",
  },
  declinedStatus: {
    color: "#f44336",
  },
});

const EnrolleeDependentDetails = ({ userId }) => {
  const classes = useStyles();

  const [dependents, setDependents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);

  useEffect(() => {
    const fetchDependents = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get(`/v1/admin/dependants/${userId}`);

        console.log("Dependents response:", res);
        setDependents(res?.data?.data[0]?.dependants || []);
      } catch (error) {
        console.error("Failed to fetch dependents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDependents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStatusChange = async (id, status) => {
    try {
      setUpdatingId(id);
      await axiosInstance.patch(`/v1/admin/dependants/${id}/status`, {
        status,
      });
      setDependents((prev) =>
        prev.map((dep) => (dep.id === id ? { ...dep, status } : dep))
      );
    } catch (error) {
      console.error("Failed to update dependent status:", error);
    } finally {
      setUpdatingId(null);
    }
  };

  if (loading) return <Loader visible />;

  return (
    <div className={styles.dependentsContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Gender</th>
            <th>DoB</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {dependents?.map((dep) => (
            <tr key={dep.id}>
              <td>
                {dep.first_name}
                {""} {dep.last_name}{" "}
              </td>
              <td>{dep.gender}</td>
              <td>{dep.dob}</td>
              <td
                className={`${classes.statusBadge} ${
                  dep.status === "approved"
                    ? classes.approvedStatus
                    : dep.status === "rejected"
                    ? classes.declinedStatus
                    : classes.pending
                }`}
              >
                {dep.status}
              </td>
              <td>
                {dep.status === "pending" ? (
                  <div className="flex gap-2">
                    <Button
                      disabled={updatingId === dep.id}
                      className={classes.approved}
                      onClick={() => handleStatusChange(dep.id, "approved")}
                    >
                      {updatingId === dep.id ? "Approving..." : "Approve"}
                    </Button>
                    <Button
                      variant="destructive"
                      disabled={updatingId === dep.id}
                      onClick={() => handleStatusChange(dep.id, "rejected")}
                      className={classes.declined}
                    >
                      {updatingId === dep.id ? "Declining..." : "Decline"}
                    </Button>
                  </div>
                ) : (
                  <span>{dep.status}</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EnrolleeDependentDetails;
